// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"59290980","488":"140f568a","605":"fcef84df","943":"2d6a697c"}[chunkId] + ".chunk.js";
};